export default "__VITE_ASSET__7956ce0a__"